"use client";

import Image from 'next/image';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { ProductByURLType } from '../../product';

const GalleryProduct = dynamic(() => import("./GalleryProduct"), {
    ssr: false
})

const GalleryImages = ({ data }: { data: ProductByURLType }) => {

    const checkMainImage = data.Albums.filter((i) => i)
    const [index, setIndex] = useState(-1);
    return (
        <div>
            <div className='mx-auto table'>
                <Image
                    height={400}
                    width={400}
                    alt={data.product_image_alt}
                    src={process.env.imageUrl + data.product_image}
                    priority
                    onClick={() => setIndex(0)}
                    style={{ cursor: 'pointer' }}
                    sizes="(max-width: 400px) 100vw, 400px"
                />
            </div>
            <GalleryProduct albumImage={checkMainImage} index={index} setIndex={setIndex} />
        </div>
    );
};

export default GalleryImages;